import 'bootstrap/dist/css/bootstrap.css';
import SearchBar from './components/SearchInput'
import FindButton from './components/FindButton'
import TableResult from './components/TableResult'
import logo from './logo.jpg'
import { Component } from 'react';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Selected from './components/Selected';
import DiscoverButton from './components/DiscoverButton'
import loadingPng from './Spin-1s-200px.gif'

class Discovery extends Component{

state = {
  tracksHome: [],
  IDhome: "",
  img: "",
  name: "",
  footerFixed: true,
  loading: false
}

handleArtistSet = (albums, side, id, name, img) => {
    if(side == "sx"){
      //setTracks1(albums)
     this.setState({tracksHome: albums,
                    IDhome: id,
                    name: name,
                    img: img})
     //console.log("tracks1 in home", this.state.tracks1Home)
     //console.log("tracks2 inh", this.state.tracks2Home)
    }
  };

  handleFooterPosition = () => {
    this.setState({ footerFixed: false});
  };

  setFooterPosition = () => {
    this.setState({footerFixed: true})
  }

  handleFinalLoading = (side, value) => {
    if(side == "sx"){
      this.setState({loading: value})
    } 
  }

render(){
  return(
    <div>
      <Navbar/>
      <div class="row" style={{textAlign: "center", marginTop: "20px"}}>
 
    <div class="col" >
    <h1>FeatFinder Discovery Mode</h1>
    <p>Select an artist to <i>discover</i> a list of collaborations</p>
    <p><i>Note: this mode shows artists that have collaborated in songs pulished by the one you choose, there might be other songs so for a deeper search use the classic mode!</i></p>
    </div>
   
  </div>
      <div class="container-md">
<div class="row" style={{textAlign: "center", marginTop: "20px"}}>
    <div class="col">
      
    </div>
    <div class="col-7">
    <SearchBar side={"sx"} onFinalArtistSet={this.handleArtistSet} onFinalLoadingSet={this.handleFinalLoading}/> 
    <input type="submit" value="Click here to change artist" class="btn btn-success" onClick={() => {window.location.reload()}} style={{ background: '#D9E724', borderColor: '#8b008b', color:'black', float: "center", marginTop: "5px"}}/>
    </div>
    <div class="col">
    </div>
  </div>
  <div class="row" style={{textAlign: "center", marginTop: "20px"}}>
    <div class="col-3">
    
    </div>
    <div class="col">
    {
      this.state.name != "" ? (
        <Selected img={this.state.img} name={this.state.name} isLoading={this.state.loading}/>
      ): this.state.loading == true ? (<img
        src={loadingPng}
        alt={""}
        style={{ width: '20vh', height: '20vh' }} // Imposta la larghezza desiderata in pixel
    />) : ("")
     }
    </div>
    <div class="col-3">
    
    </div>
  </div>
  <div class="row" style={{textAlign: "center", marginTop: "20px"}}>

    <div class="col">
     <DiscoverButton tracks={this.state.tracksHome} id={this.state.IDhome} onFinalFooterSet={this.handleFooterPosition} onFooter={this.setFooterPosition}/>
    </div>
   
  </div>
  
</div>

    </div>


)

}}

export default Discovery;